export default __webpack_public_path__ + "img/310ddca82c25a43421f64eb35a5eb562.svg";